import { createContext, useContext } from "react";
import { useTradeFlowUpdater } from "../hooks/useTradeFlowUpdater";
import { TradeFlowData } from "../types/TradeFlow";

type TradeFlowDataContextType = {
  tradeFlowData: TradeFlowData;
  updateTradeFlow: ReturnType<typeof useTradeFlowUpdater>;
  isFetching: boolean;
  openEditTab: () => void;
  refetch: () => void;
};

export const TradeFlowDataContext =
  createContext<TradeFlowDataContextType | null>(null);

export function useTradeFlowData() {
  const ctx = useContext(TradeFlowDataContext);
  if (!ctx) {
    throw new Error(
      "useTradeFlowData must be used inside <TradeFlowTracker.Data />",
    );
  }
  return ctx;
}
